import Header from '@components/Header';
import StampSheet from '@components/StampSheet';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

const AttendanceCheckActivity: ActivityComponentType = () => {
    const a = '';
    return (
        <AppScreen>
            <Header title='출석체크' />
            <StampSheet onSuccess={() => {
                alert('출석체크 성공');
            }}/>
        </AppScreen>
    );
};

export default AttendanceCheckActivity;
